import {
  CreateParams,
  DeleteManyParams,
  DeleteParams,
  GetListParams,
  GetManyParams,
  GetOneParams,
  UpdateManyParams,
  UpdateParams,
} from "react-admin";
import { DocumentData } from "./firebase.types";

import { PaginationDirection } from "./pagination.types";

export declare type DataProviderParams =
  | GetListParams
  | GetOneParams
  | GetManyParams
  | CreateParams
  | UpdateParams
  | UpdateManyParams
  | DeleteParams
  | DeleteManyParams;

// enums
export enum DataProviderKey {
  getList = "getList",
  getMany = "getMany",
  getOne = "getOne",
  create = "create",
  update = "update",
  updateMany = "updateMany",
  delete = "delete",
  deleteMany = "deleteMany",
  getManyReference = "getManyReference",
}

export enum FormGroupNames {
  userGuideEdit = "userGuideEdit",
  userGuideCreate = "userGuideCreate",
  sportsClubsEdit = "sportsClubsEdit",
  sportsClubsCreate = "sportsClubsCreate",
  categoriesEdit = "categoriesEdit",
  categoriesCreate = "categoriesCreate",
  brandCategoriesCreate = "brandCategoriesCreate",
  brandCategoriesEdit = "brandCategoriesEdit",
  faqsCreate = "faqsCreate",
  faqsEdit = "faqsEdit",
  adsCreate = "adsCreate",
  adsEdit = "adsEdit",
  brandsCreate = "brandsCreate",
  brandsEdit = "brandsEdit",
  agentsCreate = "agentsCreate",
  agentsEdit = "agentsEdit",
  productsCreate = "productsCreate",
  productsEdit = "productsEdit",
  courtsCreate = "courtsCreate",
  courtsEdit = "courtsEdit",
  settings = "settings",
  placesCreate = "placesCreate",
  placesEdit = "placesEdit",
  gymsCreate = "gymsCreate",
  gymsEdit = "gymsEdit",
  sportTypesCreate = "sportTypesCreate",
  sportTypesEdit = "sportTypesEdit",
  academiesCreate = "academiesCreate",
  academiesEdit = "academiesEdit",
  coachesCreate = "coachesCreate",
  coachesEdit = "coachesEdit",
  trainersCreate = "trainersCreate",
  trainersEdit = "trainersEdit",
  entertainmentsCreate = "entertainmentsCreate",
  entertainmentsEdit = "entertainmentsEdit",
  serviceCreate = "serviceCreate",
  serviceEdit = "serviceEdit",
  announcementsCreate = "announcementsCreate",
}

export interface IGetListParams extends GetListParams {
  direction: PaginationDirection;
  record: DocumentData;
  limit: number;
  additionalFilter: {
    autoComplete?: string;
    [key: string]: any;
  };
  operators: Record<string, any>;
  additionalOperators: Record<string, any>;
  fieldOverrides: Record<string, any>;
  fieldValueOverrides: Record<string, any>;
  user: any;
}

export const SideMenuTextColor = "#b4b4b4";
